import * as types from './constants';

// Create Lookbook Order Fulfillment
export const createLookbookOrderFulfillmentRequest = data => (
  { type: types.CREATE_LOOKBOOK_ORDER_FULFILLMENT_REQUEST, payload: data }
);

export const createLookbookOrderFulfillmentDone = data => (
  { type: types.CREATE_LOOKBOOK_ORDER_FULFILLMENT_DONE, payload: data }
);

export const createLookbookOrderFulfillmentFailed = errors => (
  { type: types.CREATE_LOOKBOOK_ORDER_FULFILLMENT_FAILED, payload: errors }
);

export const createLookbookOrderFulfillmentClearErrors = prop => (
  { type: types.CREATE_LOOKBOOK_ORDER_FULFILLMENT_CLEAR_ERRORS, payload: prop }
);

export const createLookbookOrderFulfillmentReset = () => (
  { type: types.CREATE_LOOKBOOK_ORDER_FULFILLMENT_RESET }
);
